import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "solution-more"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", {
  class: "solution-more__title"
}, "更多服务", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "solution-more__des"
}, "从基础服务做起、成为最懂出海企业需求的管家", -1);
const _hoisted_4 = [_hoisted_2, _hoisted_3];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4);
}